import { render } from "./editquotation.vue?vue&type=template&id=f2e3ba9e&scoped=true"
import script from "./editquotation.vue?vue&type=script&lang=js"
export * from "./editquotation.vue?vue&type=script&lang=js"

import "./editquotation.vue?vue&type=style&index=0&id=f2e3ba9e&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e3ba9e"]])

export default __exports__